import { render, staticRenderFns } from "./PurchaseGalleryView.vue?vue&type=template&id=9f82a588&scoped=true&"
import script from "./PurchaseGalleryView.vue?vue&type=script&lang=ts&"
export * from "./PurchaseGalleryView.vue?vue&type=script&lang=ts&"
import style0 from "./PurchaseGalleryView.vue?vue&type=style&index=0&id=9f82a588&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f82a588",
  null
  
)

export default component.exports